import useLoggedInUser from './useLoggedInUser';

const useIsLoggedIn = () => {
  const loggedInUser = useLoggedInUser();
  return !!loggedInUser?.accountId;
};

export default useIsLoggedIn;
